import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const testimonios = [
  {
    texto:
      "Con Imagy automatizamos el 100% de los turnos por WhatsApp. Antes atendíamos llamados todo el día, ahora los pacientes se agendan solos.",
    
  },
  {
    texto:
      "Imagy redujo el ausentismo en nuestra clínica. Al recordar los turnos automáticamente, logramos que los pacientes se presenten o cancelen con tiempo.",
    
  },
  {
    texto:
      "Implementarlo fue facilísimo y no necesitamos cambiar nuestro sistema. Imagy se adapta a lo que ya usábamos.",
    
  },
];

function TestimoniosSection() {
  return (
    
    <div
      style={{
        background: "linear-gradient(135deg, #FFA500 0%, #FFE0B2 100%)",
        
        padding: "60px 0"
      }}
    >
      <Container>
        <h2
          className="text-center mb-2"
          style={{ color: "#FF7A00", fontWeight: "bold" }}
        >
          ¿Qué dicen quienes usan Imagy?
        </h2>
        <h5 className="text-center mb-5" style={{ color: "#333" }}>
          Profesionales que ya  optimizaron  su tiempo con nuestro bot.
        </h5>
        <Row>
          {testimonios.map((t, idx) => (
            <Col md={4} key={idx} className="mb-5">
              <div
                style={{
                  position: "relative",
                  paddingBottom: "20px",
                }}
              >
                <Card
                  style={{
                    borderRadius: "20px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    padding: "20px",
                    backgroundColor: "white",
                    position: "relative",
                    overflow: "visible",
                  }}
                >
                  <Card.Body>
                    <Card.Title
                      style={{ color: "#cc6a00", fontWeight: "bold" }}
                    >
                      {t.numero}
                    </Card.Title>
                    <Card.Text style={{ fontStyle: "italic" }}>
                      “{t.texto}”
                    </Card.Text>
                  </Card.Body>
                </Card>

              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default TestimoniosSection;



